<template>
  <div class="row">
    <div class="col-md-8">
      <div
        class="card card-wizard active mb-0"
        data-color="primary"
        style="margin-bottom: 10px !important"
      >
        <div
          class="card-header text-center"
          style="background-color: #fbe112 !important"
        >
          <h3 class="card-title" style="color: #3c3c3c !important">
            เงื่อนไขการให้บริการ
          </h3>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-sm-12">
              <ui class="terms-ulst">
                <ul class="text-muted">
                  -
                  <span class="text-danger"
                    ><strong>กรุณาใส่เลข ID</strong></span
                  >
                  ตัวอย่างการดูเลขอยู่ด้านด้านล่าง
                </ul>
                <ul class="text-muted">
                  -
                  <span class="text-danger"
                    ><strong>หากลูกค้ากรอกเลข ID มาผิด</strong></span
                  >
                  ทางเราจะไม่รับผิดชอบและไม่มีการคืนเงินใด ๆ ทั้งสิ้น
                </ul>
                <ul class="text-muted">
                  - หากสถานะขึ้นว่า สำเร็จ กรุณารอ 5 - 60 นาที ยอดเงินจะเข้าเกม
                </ul>
                <ul class="text-muted">
                  -
                  <span class="text-danger"
                    ><strong>ไม่มีการยกเลิกรายการ</strong></span
                  >
                  หรือ ขอคืนเครดิตหลังการทำรายการแล้ว
                </ul>
                <ul class="text-muted">
                  - กรุณาโอนเงินให้ เศษ สตางค์ให้ถูกต้องตามระบบกำหนด
                </ul>
                <ul class="text-muted">
                  - หากไม่ตรงระบบจะไม่ดำเนินการ
                  และต้องนำหลักฐานการโอนเงินมาให้ทางทีมงานตรวจสอง
                  (มีระยะการดำเนินการ)
                </ul>
              </ui>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <div class="pull-right"></div>
          <div class="pull-left">
            <div class="col-sm-12 checkbox-radios">
              <checkbox v-model="checkboxes.terms" class="terms"
                >ฉัน
                <strong class="text-danger">ยอมรับ</strong>
                เงื่อนไขการให้บริการ
              </checkbox>
              <checkbox v-model="checkboxes.terms2" class="terms"
                >ฉันจะโอนยอดทศนิยมตรง โดย
                <strong class="text-danger">ไม่ปัดเศษ</strong>
              </checkbox>
            </div>
          </div>
          <div class="clearfix"></div>
        </div>
      </div>
    </div>
    <div class="col-md-4">
      <div class="card">
        <div class="row">
          <div class="col-md-12">
            <div class="card-header">
              <h4 class="card-title">รายละเอียดสินค้า</h4>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <div class="row terms-prodoct-info">
            <div class="col-4">
              <b>ชื่อเกม</b>
            </div>
            <div class="col-8">{{ this.game.name }}</div>
          </div>
          <div class="row terms-prodoct-info">
            <div class="col-4">
              <b>วิธีการชำระเงิน</b>
            </div>
            <div class="col-8">
              {{ this.gamePackage.paymentMethod.name }}
            </div>
          </div>
          <div class="row terms-prodoct-info" v-for="f in fields" :key="f.text">
            <div class="col-4">
              <b>{{ f.text }}</b>
            </div>
            <div class="col-8">{{ f.value }}</div>
          </div>
          <div
            class="row terms-prodoct-info"
            v-if="this.gamePackage.paymentMethod.code === 'bank'"
          >
            <div class="col-4">
              <b>ธนาคาร</b>
            </div>
            <div class="col-8">
              {{ this.gamePackage.bank.bankName }} สาขา
              {{ this.gamePackage.bank.branch }}
            </div>
          </div>
          <div
            class="row terms-prodoct-info"
            v-if="this.gamePackage.paymentMethod.code !== 'wallet'"
          >
            <div class="col-4">
              <b>ชื่อบัญชี</b>
            </div>
            <div class="col-8">
              {{ this.gamePackage.bank.accountName }}
            </div>
          </div>
          <div
            class="row terms-prodoct-info"
            v-if="this.gamePackage.paymentMethod.code !== 'wallet'"
          >
            <div class="col-4">
              <b>เลขที่บัญชี</b>
            </div>
            <div class="col-8">
              {{ this.gamePackage.bank.accountNo }}
            </div>
          </div>
          <div class="row terms-prodoct-info">
            <div class="col-4">
              <b>Package</b>
            </div>
            <div class="col-8">{{ this.gamePackage.package.name }}</div>
          </div>
          <div class="row">
            <div class="col-4">
              <b>ราคา</b>
            </div>
            <div class="col-8">
              {{ this.gamePackage.package.price
              }}{{
                this.gamePackage.paymentMethod.code === "wallet" ? "" : ".xx"
              }}
            </div>
          </div>
          <hr />
          <div class="row">
            <div class="col-md-12">
              <n-button
                type="info"
                style="width: 100%; margin-bottom: 10px"
                @click="nextStep"
                :disabled="!(checkboxes.terms && checkboxes.terms2)"
                >{{
                  this.gamePackage.paymentMethod.code === "wallet"
                    ? "ยืนยันการสั่งซื้อ"
                    : "ดำเนินการต่อ"
                }}</n-button
              >
              <div class="row">
                <div class="col-md-6">
                  <n-button
                    type="default"
                    style="width: 100%; margin-bottom: 10px"
                    @click="onBack"
                  >
                    ย้อนกลับ</n-button
                  >
                </div>
                <div class="col-md-6">
                  <n-button
                    class="btn-outline-info"
                    @click="cancelOrder"
                    style="width: 100%"
                  >
                    <span class="btn-label"
                      ><em class="now-ui-icons ui-1_simple-remove"></em
                    ></span>
                    ยกเลิกคำสั่งซื้อ</n-button
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Checkbox } from "@/components/index";
import Swal from "sweetalert2";
import * as configuration from "../../../middleware/configuration";
import * as paymentservice from "../../../services/payment";

export default {
  components: {
    Checkbox,
  },
  methods: {
    onTermsChange(value) {
      this.checkboxes.terms = value.terms;
      this.checkboxes.terms2 = value.terms2;
    },
    onBack() {
      this.$router.push({
        name: "Package Choose",
        params: { code: this.game.code, isback: true },
      });
    },
    cancelOrder() {
      const swal2 = Swal.mixin({
        confirmButtonText: "ใช่",
        cancelButtonText: "ไม่ใช่",
        showCancelButton: true,
        customClass: {
          confirmButton: "btn btn-info",
          cancelButton: "btn btn-default",
        },
        buttonsStyulng: false,
      });
      swal2
        .fire({
          title: "ยกเลิกคำสั่งซื้อ",
          text: "คุณต้องการยกเลิกคำสั่งซื้อหรือไม่?",
        })
        .then((result) => {
          if (result.isConfirmed) {
            localStorage.removeItem("AcceptTerm");
            localStorage.removeItem("GamePackage");
            this.$router.push("/game");
          }
        });
    },
    async nextStep() {
      let uid = await configuration.getUid();
      localStorage.setItem("AcceptTerm", true);
      if (uid !== "") {
        if (this.gamePackage.paymentMethod.code === "wallet") {
          const confirm = Swal.mixin();
          confirm
            .fire({
              title: "กรุณากรอก PIN เพื่อยืนยันการเติมเงิน",
              input: "password",
              inputAttributes: {
                autocapitalize: "off",
              },
              showCancelButton: true,
              confirmButtonText: "ยืนยัน",
              cancelButtonText: "ย้อนกลับ",
              showLoaderOnConfirm: true,
              preConfirm: async (pin) => {
                try {
                  let res = await paymentservice.checkPin(pin ?? "abc");
                  if (!res.data) {
                    Swal.showValidationMessage(`PIN ไม่ถูกต้อง`);
                    return res.data;
                  }
                } catch (error) {
                  Swal.showValidationMessage(`PIN ไม่ถูกต้อง`);
                }
              },
              allowOutsideClick: () => !Swal.isLoading(),
            })
            .then(async (result) => {
              if (result.isConfirmed) {
                this.$router.push("/payment");
              }
            });
        } else {
          this.$router.push("/payment");
        }
      } else {
        this.$router.push("/login");
      }
    },
  },
  data() {
    return {
      checkboxes: {
        terms: false,
        terms2: false,
      },
      game: {},
      gamePackage: {},
      price: 0,
      txtPrice: "0",
      randId: "",
      gameId: "",
      fields: [],
    };
  },
  beforeMount() {
    if (localStorage.getItem("GamePackage") === null) {
      this.$router.push("/game");
    }
    if (localStorage.getItem("AcceptTerm")) {
      this.$router.push("/payment");
    }
    var gamePackage = JSON.parse(localStorage.getItem("GamePackage"));
    this.gamePackage = gamePackage;
    var game = JSON.parse(localStorage.getItem("GameList"));
    this.game = game.find((x) => x.id == gamePackage.gameId);
    let fields = [];
    for (let i = 1; i <= 5; i++) {
      if (this.game["field" + i + "IsActived"]) {
        fields.push({
          text: this.game["field" + i],
          value: gamePackage["field" + i],
        });
      }
    }
    this.fields = fields;
  },
};
</script>

<style>
.tbtn {
  margin: 5px !important;
}
.terms-prodoct-info {
  margin-bottom: 5px;
}
</style>